import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { Store } from '@ngxs/store';
import { AppState } from '@taxora-business-core/data-access/state/app.state';
import { APP_ROUTES } from '@taxora-business-core/util/constants/app-routes.constant';

export const authGuard: CanActivateFn = () => {
  const store = inject(Store);
  const accessToken = store.selectSnapshot(AppState.accessToken);

  if (accessToken) {
    const router = inject(Router);
    router.navigate([APP_ROUTES.DASHBOARD]);
    return false;
  }

  return true;
};
